import { API_GET_VERIFY_TOKEN } from '@/services/api'
import type { VerifyTokenOutcome, VerifyTokenResponse } from '@/types/auth'

export async function verifyToken(
  authKey: string,
  signal?: AbortSignal,
): Promise<VerifyTokenOutcome> {
  try {
    const response = await fetch(API_GET_VERIFY_TOKEN, {
      cache: 'no-store',
      headers: { authKey },
      method: 'GET',
      signal,
    })

    const data = (await response.json()) as VerifyTokenResponse
    return data.outcome
  } catch {
    return 'retry'
  }
}
